'use strict';
const angular = require('angular');

/*@ngInject*/
export function SurveyResultsService($resource) {
  return $resource('/api/survey-results/:id', {
    id: '@_id'
  },{
    getSurveyResultByUser: {
      method: 'GET',
      url: "/api/survey-results/survey/:survey/user/:user"
    },
    getSurveyResultByBuildingAndUnit: {
      method: 'GET',
      url: "/api/survey-results/survey/:survey/building/:building/unit/:unit"
    },
    getResultsBySurvey: {
      method: 'GET',
      url: "/api/survey-results/survey/:survey",
      isArray: true
    },
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduu.SurveyResultsService', [])
  .factory('SurveyResultsService', SurveyResultsService)
  .name;



// WEBPACK FOOTER //
// ./client/services/survey-results/survey-results.service.js